/* DEZ consent strip · markup in snippets/dez-consent.liquid, styles in assets/dez-consent.css.
   - Remembers the choice in localStorage "dez_consent_v1" ({v, ts, choice, analytics, marketing, preferences})
     for 180 days. Accept, decline and custom choices are all remembered.
   - Writes the choice to Shopify's Customer Privacy API (consent-tracking-api 0.1, setTrackingConsent).
   - Shows only when the visitor has not chosen and Shopify's own banner is not shown here
     (!shouldShowBanner() && getTrackingConsent() === 'no_interaction'). If the API fails,
     the bar still shows and the choice is stored locally.
   - Never blocks other layers: it steps aside while any popup, drawer, cart, quick-add or tour step is open.
   - Reopen: window.DezConsent.open() or any link with href ending in "#cookie-settings". */
(function () {
  'use strict';
  if (window.DezConsent) return;

  var KEY = 'dez_consent_v1';
  var MAX_AGE = 180 * 24 * 60 * 60 * 1000;
  var API_TIMEOUT = 4000;

  var bar = document.getElementById('dez-consent');
  if (!bar) return;
  var panel = document.getElementById('dez-consent-panel');
  var settingsBtn = bar.querySelector('[data-dez-consent="settings"]');
  var opts = bar.querySelectorAll('[data-dez-consent-opt]');

  var api = null;          // Shopify.customerPrivacy once loaded
  var apiState = 'loading'; // loading | ready | failed
  var wanted = false;      // bar should be on screen (ignoring yielding)
  var lastFocus = null;
  var watchTimer = 0;

  /* ---------- local storage ---------- */
  function readLocal() {
    try {
      var raw = localStorage.getItem(KEY);
      if (!raw) return null;
      var d = JSON.parse(raw);
      if (!d || !d.ts || Date.now() - d.ts > MAX_AGE) return null;
      return d;
    } catch (e) { return null; }
  }
  function writeLocal(choice, c) {
    var d = { v: 1, ts: Date.now(), choice: choice, analytics: !!c.analytics, marketing: !!c.marketing, preferences: !!c.preferences };
    try { localStorage.setItem(KEY, JSON.stringify(d)); } catch (e) {}
    return d;
  }

  /* ---------- Shopify Customer Privacy API ---------- */
  function loadApi(cb) {
    var done = false;
    function finish(ok) {
      if (done) return;
      done = true;
      api = ok && window.Shopify && window.Shopify.customerPrivacy ? window.Shopify.customerPrivacy : null;
      apiState = api ? 'ready' : 'failed';
      cb();
    }
    setTimeout(function () { finish(false); }, API_TIMEOUT);
    try {
      if (window.Shopify && window.Shopify.customerPrivacy) return finish(true);
      if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return finish(false);
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) { finish(!err); });
    } catch (e) { finish(false); }
  }
  function apiCall(name) {
    try { return api && typeof api[name] === 'function' ? api[name]() : undefined; } catch (e) { return undefined; }
  }
  function pushToApi(c, cb) {
    if (!api || typeof api.setTrackingConsent !== 'function') { if (cb) cb(); return; }
    try {
      api.setTrackingConsent({
        analytics: !!c.analytics,
        marketing: !!c.marketing,
        preferences: !!c.preferences,
        sale_of_data: !!c.marketing
      }, function () { if (cb) cb(); });
    } catch (e) { if (cb) cb(); }
  }
  function apiConsent() {
    var v = apiCall('currentVisitorConsent');
    if (!v) return null;
    return { analytics: v.analytics === 'yes', marketing: v.marketing === 'yes', preferences: v.preferences === 'yes' };
  }

  /* ---------- layers the bar steps aside for ---------- */
  function visible(el) {
    if (!el || !el.getClientRects().length) return false;
    var s = window.getComputedStyle(el);
    return s.display !== 'none' && s.visibility !== 'hidden' && s.opacity !== '0';
  }
  function layerOpen() {
    var b = document.body;
    if (!b) return false;
    if (b.classList.contains('u-scroll-disabled') || b.classList.contains('dez-vip-open') || b.classList.contains('dez-qs-drawer-open')) return true;
    var cart = document.getElementById('modal-cart');
    if (cart && cart.getAttribute('aria-hidden') === 'false') return true;
    var list = document.querySelectorAll('modal-dialog, popup-dialog, quick-shop, search-modal, drawer-menu');
    for (var i = 0; i < list.length; i++) {
      var el = list[i];
      if (el.getAttribute('aria-hidden') === 'true') continue;
      if (el.hasAttribute('hidden')) continue;
      if (!visible(el)) continue;
      return true;
    }
    var ov = document.getElementById('st-overlay');
    if (ov && ov.classList.contains('is-visible')) return true;
    var tip = document.getElementById('st-tooltip');
    if (tip && tip.hidden === false && tip.getClientRects().length) return true;
    if (document.getElementById('st-highlight-ring') || document.getElementById('st-swipe-demo')) return true;
    var vip = document.getElementById('vip-popup-overlay');
    if (vip && vip.style.display !== 'none' && vip.getAttribute('aria-hidden') !== 'true') return true;
    var shopifyBanner = document.getElementById('shopify-pc__banner');
    if (shopifyBanner && visible(shopifyBanner)) return true;
    return false;
  }

  /* ---------- layout: sit above the product sticky add-to-cart, publish height ---------- */
  function stickyOffset() {
    var s = document.getElementById('dez-sticky-atc');
    if (!s || !s.classList.contains('is-visible') || !visible(s)) return 0;
    var r = s.getBoundingClientRect();
    if (r.height < 1) return 0;
    return Math.max(0, Math.round(window.innerHeight - r.top));
  }
  function sync() {
    var body = document.body;
    if (!body) return;
    if (!wanted) {
      bar.hidden = true;
      bar.classList.remove('is-yielding');
      body.classList.remove('dez-consent-open');
      body.style.removeProperty('--dez-consent-h');
      return;
    }
    if (bar.hidden) bar.hidden = false;
    var yielding = layerOpen();
    if (bar.classList.contains('is-yielding') !== yielding) bar.classList.toggle('is-yielding', yielding);
    if (yielding && bar.contains(document.activeElement)) {
      try { document.activeElement.blur(); } catch (e) {}
    }
    var off = stickyOffset();
    // Write only when a value changes: rewriting the same styles every tick
    // forced a full-page style/layout pass and slowed page load.
    setVar(bar, '--dez-consent-bottom', off + 'px');
    if (yielding) {
      if (body.classList.contains('dez-consent-open')) body.classList.remove('dez-consent-open');
      if (body.style.getPropertyValue('--dez-consent-h')) body.style.removeProperty('--dez-consent-h');
    } else {
      if (!body.classList.contains('dez-consent-open')) body.classList.add('dez-consent-open');
      setVar(body, '--dez-consent-h', Math.ceil(bar.getBoundingClientRect().height) + 'px');
    }
  }
  function setVar(el, name, val) {
    if (el.style.getPropertyValue(name) !== val) el.style.setProperty(name, val);
  }
  var raf = 0;
  function scheduleSync() {
    if (raf) return;
    raf = requestAnimationFrame(function () { raf = 0; sync(); });
  }
  var watchTick = 0;
  function startWatch() {
    if (watchTimer) return;
    // Fallback poll (events + class observer catch most changes). Gentler
    // while the page is still loading, then every 400ms as before.
    watchTimer = setInterval(function () {
      if (document.hidden) return;
      if (document.readyState !== 'complete' && (watchTick = (watchTick + 1) % 2)) return;
      sync();
    }, 400);
    window.addEventListener('resize', scheduleSync);
    window.addEventListener('scroll', scheduleSync, { passive: true });
    ['on:modal:opening', 'on:modal:opened', 'on:modal:closing', 'on:modal:closed', 'dez:sale:popup'].forEach(function (n) {
      document.addEventListener(n, scheduleSync, true);
    });
    try {
      new MutationObserver(scheduleSync).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    } catch (e) {}
  }
  function stopWatch() {
    if (!watchTimer) return;
    clearInterval(watchTimer);
    watchTimer = 0;
  }

  /* ---------- show / hide ---------- */
  function setOpts(c) {
    for (var i = 0; i < opts.length; i++) opts[i].checked = !!(c && c[opts[i].getAttribute('data-dez-consent-opt')]);
  }
  function toggleSettings(open) {
    panel.hidden = !open;
    settingsBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    bar.classList.toggle('is-settings', open);
    scheduleSync();
  }
  function show(withSettings) {
    wanted = true;
    toggleSettings(!!withSettings);
    startWatch();
    sync();
  }
  function hide() {
    wanted = false;
    toggleSettings(false);
    stopWatch();
    sync();
  }

  function decide(choice, c) {
    var d = writeLocal(choice, c);
    var hadFocus = bar.contains(document.activeElement);
    hide();
    if (hadFocus) {
      if (lastFocus && document.contains(lastFocus) && typeof lastFocus.focus === 'function') {
        try { lastFocus.focus(); } catch (e) {}
      }
    }
    lastFocus = null;
    var after = function () {
      try { document.dispatchEvent(new CustomEvent('dez:consent', { detail: d })); } catch (e) {}
    };
    if (apiState === 'ready') pushToApi(c, after);
    else if (apiState === 'loading') loadApiOnce(function () { pushToApi(c, after); });
    else after();
  }

  bar.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-dez-consent]');
    if (!btn) return;
    var act = btn.getAttribute('data-dez-consent');
    if (act === 'accept') decide('accept', { analytics: true, marketing: true, preferences: true });
    else if (act === 'decline') decide('decline', { analytics: false, marketing: false, preferences: false });
    else if (act === 'settings') toggleSettings(panel.hidden);
    else if (act === 'save') {
      var c = {};
      for (var i = 0; i < opts.length; i++) c[opts[i].getAttribute('data-dez-consent-opt')] = opts[i].checked;
      decide('custom', c);
    }
  });

  /* ---------- reopen ---------- */
  function open() {
    var cur = (readLocal()) || (apiState === 'ready' && apiConsent()) || null;
    setOpts(cur);
    lastFocus = document.activeElement;
    show(true);
    var first = bar.querySelector('[data-dez-consent-opt]');
    setTimeout(function () { if (first && !bar.classList.contains('is-yielding')) try { first.focus(); } catch (e) {} }, 50);
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (!/#cookie-settings$/.test(href)) return;
    e.preventDefault();
    open();
  });

  /* ---------- API sync ---------- */
  var apiQueue = null;
  function loadApiOnce(cb) {
    if (apiState !== 'loading' || apiQueue) {
      if (apiQueue) apiQueue.push(cb); else cb();
      return;
    }
    apiQueue = [cb];
    loadApi(function () {
      var q = apiQueue; apiQueue = null;
      q.forEach(function (fn) { try { fn(); } catch (e) {} });
    });
  }

  document.addEventListener('visitorConsentCollected', function (e) {
    // Shopify banner, another tab or our own call recorded consent: keep the local copy in step.
    var d = e && e.detail;
    if (d && typeof d === 'object' && ('analyticsAllowed' in d || 'marketingAllowed' in d)) {
      var c = { analytics: !!d.analyticsAllowed, marketing: !!d.marketingAllowed, preferences: !!d.preferencesAllowed };
      // Only fill a missing local copy; a choice made in this bar stays as the user made it.
      if (!readLocal()) {
        writeLocal(c.analytics && c.marketing && c.preferences ? 'accept' : (!c.analytics && !c.marketing && !c.preferences ? 'decline' : 'custom'), c);
      }
    }
    if (wanted && panel.hidden) hide();
  });

  function boot() {
    var local = readLocal();
    var wantsSettings = location.hash === '#cookie-settings';
    if (wantsSettings) open();
    if (local) {
      // Already chose: stay hidden. Later, quietly make sure Shopify has the same choice.
      var later = window.requestIdleCallback || function (fn) { return setTimeout(fn, 2500); };
      later(function () {
        loadApiOnce(function () {
          if (!api) return;
          if (apiCall('shouldShowBanner')) return; // Shopify's banner owns this region
          if (apiCall('getTrackingConsent') === 'no_interaction') pushToApi(local);
        });
      });
      return;
    }
    loadApiOnce(function () {
      if (wantsSettings) return;
      if (apiState === 'ready') {
        if (apiCall('shouldShowBanner')) return; // Shopify's own banner will ask; never double up
        var tc = apiCall('getTrackingConsent');
        if (tc && tc !== 'no_interaction') {
          // Chosen before (Shopify cookie): remember locally, no bar.
          var c = apiConsent() || { analytics: tc === 'yes', marketing: tc === 'yes', preferences: tc === 'yes' };
          writeLocal(tc === 'yes' ? 'accept' : tc === 'no' ? 'decline' : 'custom', c);
          return;
        }
      }
      show(false);
    });
  }

  window.DezConsent = {
    open: open,
    get: readLocal,
    reset: function () { try { localStorage.removeItem(KEY); } catch (e) {} }
  };

  try {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
    else boot();
  } catch (e) {}
})();
